import axiosClient from './axiosClient'

export const getEvents = (filters,  axiosErrorHandler = undefined) => {
    return axiosClient.get(`/events/`, { errorHandler: axiosErrorHandler });
}